// import { BEARER_TOKEN, CHAT_STREAM_API_URL } from './apiConfig';
const CHAT_STREAM_API_URL = process.env.REACT_APP_CHAT_STREAM_API_URL || '';
const BEARER_TOKEN = process.env.REACT_APP_BEARER_TOKEN || '';

const chatAgent = async (
	content: string,
	conversationId: string,
	agentId: string,
	agentAliasId: string,
	appId: string,
	retryAttempt = 0
): Promise<any> => {
	try {
		const apiUrl = `${CHAT_STREAM_API_URL}/chatagent/`;
		const requestOptions = {
			method: 'POST',
			headers: {
				Bearer: `${BEARER_TOKEN}`,
				conversation_id: conversationId,
				session_id: conversationId,
				app_id: appId,
				'content-type': 'application/json',
			},
			body: JSON.stringify({
				agent_id: agentId,
				agent_alias_id: agentAliasId,
				input_text: content
			})
		};

		const response = await fetch(apiUrl, requestOptions);
		const responseType = response.headers.get('content-type');
		const sessionConversationId = response.headers.get('x-conversation-id');
		const sessionTimeToLive = response.headers.get('x-time-to-live');
		const traceId = response.headers.get('x-trace-id');

		if (!response.ok) {
			if (retryAttempt === 0) {
				return chatAgent(content, conversationId, agentId, agentAliasId, appId, 1);
			}

			const errorMessage = 'Ha ocurrido un error, vuelve a intentar';
			
			if (response.status >= 400) {
				const errorData = await response.json();
				console.error('Validation error:', errorData);
			}

			throw new Error(errorMessage);
		}

		if (responseType?.includes('text/event-stream')) {
			return {
				data: response,
				conversationId: sessionConversationId,
				timeToLive: sessionTimeToLive,
				traceId: traceId,
				type: 'stream'
			};
		} else if (responseType?.includes('application/json')) {
			const data = await response.json();
			
			if (data.statusCode >= 500) {
				if (retryAttempt === 0) {
					return chatAgent(content, conversationId, agentId, agentAliasId, appId, 1);
				}
				throw new Error('Ha ocurrido un error, vuelve a intentar');
			}

			return {
				data,
				conversationId: sessionConversationId,
				timeToLive: sessionTimeToLive,
				traceId: traceId,
				type: 'json'
			};
		}

		throw new Error('Ha ocurrido un error, vuelve a intentar');
	} catch (error) {
		console.error('Chat agent error:', error);
		throw error;
	}
};

export default chatAgent;
